import { UserProfile } from "@clerk/react";
import { PageHeader } from "@/pages/admin/AdminLayout";

export default function AdminAccount() {
  return (
    <div>
      <PageHeader title="Akun & Password" />
      <p className="mb-4 text-sm text-stone-600">
        Ganti password di bagian Keamanan. Lupa password? Keluar, lalu di halaman Masuk pilih "Lupa kata sandi?" dan kode reset akan dikirim ke email terdaftar.
      </p>
      <div data-testid="admin-account-profile">
        <UserProfile routing="path" path="/admin/akun" />
      </div>
    </div>
  );
}
